import { LOCALE } from '../../../i18n/LOCALE'

export const experimentFreeGiftPromotionTranslations: Record<LOCALE, string> = {
  [LOCALE.DE_AT]: 'Ihr Geschenk',
  [LOCALE.DE_CH]: 'Ihr Geschenk',
  [LOCALE.DE_DE]: 'Ihr Geschenk',
  [LOCALE.FR_BE]: 'Votre cadeau',
  [LOCALE.FR_CH]: 'Votre cadeau',
  [LOCALE.FR_FR]: 'Votre cadeau',
  [LOCALE.IT_IT]: 'Il vostro regalo',
  [LOCALE.NL_BE]: 'Jouw cadeau',
}
